import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Autocomplete,
  FormGroup,
  Checkbox,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchButton from "../../components/search/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUpload from "../../components/button/Cloudupload";
import { Link, useNavigate } from "react-router-dom";
import { createenquiry, getenquiry } from "../../slices/enquiry";
import { getregion } from "../../slices/setting";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { createdemo } from "../../slices/demo";
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';

const Adddemo = ({ setLoader, show }) => {

    const [feedback_details, setFeedDetails] = useState([
      { name: 'Looks', rating: '', remarks: '' },
      { name: 'Interior', rating: '', remarks: '' },
      { name: 'Pickup/ Acceleration', rating: '', remarks: '' },
      { name: 'Riding Comfort', rating: '', remarks: '' },
      { name: 'Driving Comfort', rating: '', remarks: '' },
    ]);

      const {enquiry: enquiryData} = useSelector((state) => state.enquiry);

      console.log(enquiryData)

  const user = JSON.parse(localStorage.getItem('user'));

  const validationSchema = Yup.object({
    enquiry_no: Yup.string().required("Enquiry Number is required"),
    demo_date: Yup.string().required("Sales Type is required"),
    model_family: Yup.string().required("Model Family is required"),
    model_code: Yup.string().required("Model Code is required"),
    model_variant: Yup.string().required("Model variant is required"),
    model_desc: Yup.string().required("Model Desc is required"),
    customer_name: Yup.string().required("Customer Name is required"),
    mobile_no: Yup.string().required("Phone Number is required"),
    given_by: Yup.string().required("Given By is required"),
  });

  const formik = useFormik({
  initialValues: {
  dealer_id: user.dealer_id,
  enquiry_no: "",
  enquiry_date: null,
  demo_date: dayjs(),
  model_family:"",
  model_code:"",
  model_variant:"",
  model_desc:"",
  customer_name:"",
  given_by:"",
  overall_rating:"",
  mobile_no:"",
  comments:"",
  start_time:dayjs(),
  end_time:dayjs(),
  start_km:"",
  end_km:"",
  temp_reg_no:"",
  feedback_details: feedback_details
  },
    validationSchema,
    onSubmit: (values) => {
      console.log('Form Data:', values);
    setLoader(true)
    dispatch(createdemo({...values, enquiry_date: (values.enquiry_date).format('YYYY-MM-DD'), demo_date: (values.demo_date).format('YYYY-MM-DD HH:mm'), start_time:(values.start_time).format('HH:mm'), end_time:(values.end_time).format('HH:mm'), mobile_no: String(values.mobile_no), start_km: String(values.start_km), end_km: String(values.end_km)}))
    .then(() => {
      navigate("/demo");
      setLoader(false);
    })
    .catch(()=>{
      setLoader(false);
    })
    },
  });

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const arrowBack = () => {
    navigate(-1);
  };

    useEffect(()=>{
      setLoader(true)
        dispatch(getenquiry())
        .then(() => {
          setLoader(false);
        })
        .catch(()=>{
          setLoader(false);
        })
    }, [])


  return (
    <div className="content" style={{ marginLeft: show ? "220px" : "10px" }}>
      <Box  component="form"
    noValidate
    autoComplete="off"
    onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} sx={{ paddingBottom: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >

            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5" sx={{fontWeight:'bold'}}>New Demo</Typography>
          </Grid>
          <Grid item xs={3}>
                <Typography mb={1}>Enquiry No *</Typography>
                   <FormControl size="small" fullWidth>
                         <Select
                           labelId="demo-simple-select-label"
                           id="demo-simple-select"
                           name="enquiry_no"
                           value={formik.values.enquiry_no}
                           onChange={(newValue) => {
                            console.log(newValue.target.value);
      formik.setFieldValue( 'enquiry_no', newValue.target.value);
      formik.setFieldValue( 'enquiry_date', dayjs(enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.enquiry_date));
      formik.setFieldValue( 'customer_name', enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.first_name);
      formik.setFieldValue( 'mobile_no', enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.phone);
      formik.setFieldValue( 'model_family', enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.vehicle_details?.model_code);
      formik.setFieldValue( 'model_code', enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.vehicle_details?.model_code);
      formik.setFieldValue( 'model_variant', enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.vehicle_details?.model_color);
      formik.setFieldValue( 'model_desc', enquiryData?.filter(ab => ab.enquiry_id === newValue.target.value)[0]?.vehicle_details?.model_desc);
    }}
                    onBlur={formik.handleBlur}
                 
                                 >
                                 {enquiryData?.map((va, index)=>(
                                  <MenuItem key={index} value={va.enquiry_id}>{va.enquiry_id}</MenuItem>
                                 ))}
                         </Select>
                         {formik.touched.enquiry_no && formik.errors.enquiry_no && (
    <FormHelperText error={formik.touched.enquiry_no && Boolean(formik.errors.enquiry_no)}>{formik.errors.enquiry_no}</FormHelperText>
  )}
                         </FormControl>                              
                </Grid>
          <Grid item xs={3}>
                                <Typography >Enquiry Date & Time *</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['MobileDateTimePicker']}>
                        <DateTimePicker 
                        readOnly
                        format="LLL" 
                        onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue( 'enquiry_date', formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError('enquiry_date', "Invalid date");
      }
    }}
                        name="enquiry_date"
                        value={formik.values.enquiry_date}
                      onBlur={formik.handleBlur}
                      error={formik.touched.enquiry_date && Boolean(formik.errors.enquiry_date)}
                      helperText={formik.touched.enquiry_date && formik.errors.enquiry_date}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
                                <Typography >Demo Date & Time *</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['MobileDateTimePicker']}>
                        <DateTimePicker 
                        format="LLL" 
                        onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue( 'demo_date', formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError('demo_date', "Invalid date");
      }
    }}
                        name="demo_date"
                        value={formik.values.demo_date}
                      onBlur={formik.handleBlur}
                      error={formik.touched.demo_date && Boolean(formik.errors.demo_date)}
                      helperText={formik.touched.demo_date && formik.errors.demo_date}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
                <Typography mb={1}>Model Family *</Typography>
                <TextField
                size="small"
                fullWidth
                name="model_family"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.model_family}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.model_family && Boolean(formik.errors.model_family)}
                    helperText={formik.touched.model_family && formik.errors.model_family}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Model Variant *</Typography>
                <TextField
                size="small"
                fullWidth
                name="model_variant"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.model_variant}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.model_variant && Boolean(formik.errors.model_variant)}
                    helperText={formik.touched.model_variant && formik.errors.model_variant}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Model Code *</Typography>
                <TextField
                size="small"
                fullWidth
                name="model_code"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.model_code}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.model_code && Boolean(formik.errors.model_code)}
                    helperText={formik.touched.model_code && formik.errors.model_code}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Model Description *</Typography>
                <TextField
                size="small"
                fullWidth
                name="model_desc"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.model_desc}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.model_desc && Boolean(formik.errors.model_desc)}
                    helperText={formik.touched.model_desc && formik.errors.model_desc}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Customer Name *</Typography>
                <TextField
                size="small"
                fullWidth
                name="customer_name"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.customer_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.customer_name && Boolean(formik.errors.customer_name)}
                    helperText={formik.touched.customer_name && formik.errors.customer_name}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Mobile Number *</Typography>
                 <TextField
                                size="small"
                                fullWidth
                                id="outlined-basic"
                                variant="outlined"
                                name="mobile_no"
                                value={formik.values.mobile_no}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    error={formik.touched.mobile_no && Boolean(formik.errors.mobile_no)}
                                    helperText={formik.touched.mobile_no && formik.errors.mobile_no}
                                    type="number"
                                      onInput={(e) => {
                                    e.target.value = e.target.value.slice(0, 10);
                                  }}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  sx={{
                    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
                      WebkitAppearance: 'none',
                      margin: 0,
                    },
                    '& input[type="number"]': {
                      MozAppearance: 'textfield', // For Firefox
                    },
                  }}
                              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Given By *</Typography>
                <TextField
                size="small"
                fullWidth
                name="given_by"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.given_by}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.given_by && Boolean(formik.errors.given_by)}
                    helperText={formik.touched.given_by && formik.errors.given_by}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Comments *</Typography>
                <TextField
                size="small"
                fullWidth
                name="comments"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.comments}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.comments && Boolean(formik.errors.comments)}
                    helperText={formik.touched.comments && formik.errors.comments}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography>Start Time *</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['MobileDateTimePicker']}>
                        <MobileTimePicker 
                        onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue( 'start_time', formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError('start_time', "Invalid date");
      }
    }}
                        name="start_time"
                        value={formik.values.start_time}
                      onBlur={formik.handleBlur}
                      error={formik.touched.start_time && Boolean(formik.errors.start_time)}
                      helperText={formik.touched.start_time && formik.errors.start_time}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                <Typography>End Time *</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['MobileDateTimePicker']}>
                        <MobileTimePicker 
                        onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue( 'end_time', formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError('end_time', "Invalid date");
      }
    }}
                        name="end_time"
                        value={formik.values.end_time}
                      onBlur={formik.handleBlur}
                      error={formik.touched.end_time && Boolean(formik.errors.end_time)}
                      helperText={formik.touched.end_time && formik.errors.end_time}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Start KM *</Typography>
                <TextField
                size="small"
                fullWidth
                name="start_km"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.start_km}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.start_km && Boolean(formik.errors.start_km)}
                    helperText={formik.touched.start_km && formik.errors.start_km}
                    type="number"
                                      onInput={(e) => {
                                    e.target.value = e.target.value.slice(0, 10);
                                  }}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  sx={{
                    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
                      WebkitAppearance: 'none',
                      margin: 0,
                    },
                    '& input[type="number"]': {
                      MozAppearance: 'textfield', // For Firefox
                    },
                  }}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>End KM *</Typography>
                <TextField
                size="small"
                fullWidth
                name="end_km"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.end_km}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.end_km && Boolean(formik.errors.end_km)}
                    helperText={formik.touched.end_km && formik.errors.end_km}
                    type="number"
                                      onInput={(e) => {
                                    e.target.value = e.target.value.slice(0, 10);
                                  }}
                                  onKeyDown={(e) => {
                                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  sx={{
                    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
                      WebkitAppearance: 'none',
                      margin: 0,
                    },
                    '& input[type="number"]': {
                      MozAppearance: 'textfield', // For Firefox
                    },
                  }}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Overall Rating *</Typography>
                <FormControl fullWidth>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="overall_rating"
                  value={formik.values.overall_rating}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.overall_rating && Boolean(formik.errors.overall_rating)}
                    helperText={formik.touched.overall_rating && formik.errors.overall_rating}
                >
                  <FormControlLabel
                    value="1"
                    control={<Radio />}
                    label="1"
                  />
                  <FormControlLabel
                    value="2"
                    control={<Radio />}
                    label="2"
                  />
                  <FormControlLabel
                    value="3"
                    control={<Radio />}
                    label="3"
                  />
                  <FormControlLabel
                    value="4"
                    control={<Radio />}
                    label="4"
                  />
                  <FormControlLabel
                    value="5"
                    control={<Radio />}
                    label="5"
                  />
                </RadioGroup>
                {formik.touched.overall_rating && formik.errors.overall_rating && (
    <FormHelperText error={formik.touched.overall_rating && Boolean(formik.errors.overall_rating)}>{formik.errors.overall_rating}</FormHelperText>
  )}
              </FormControl>
                </Grid>

                <Grid item xs={12}>
            <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Feedback Details</Typography>
          </Grid>
          <Grid item xs={1}>
                <Typography>
                  SR.No
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography>
                  Attribute
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <Typography>
                  Rating
                </Typography>
            </Grid>
            <Grid item xs={5}>
                <Typography>
                  Remarks
                </Typography>
            </Grid>
          <Grid item xs={12}>
          {formik.values.feedback_details.map((vechile, index) => (
            <Grid container spacing={2} marginBottom={2} alignItems={'center'}>
            <Grid item xs={1}>
                <Typography>
                  {index+1}
                </Typography>
            </Grid>
            <Grid item xs={3}>
                <TextField
                inputProps={{
                  readOnly: true
                }}
                size="small"
                fullWidth
                placeholder="attribute"
                id="outlined-basic"
                variant="outlined"
                name={`feedback_details[${index}].name`}
                      value={vechile.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.feedback_details &&
                        formik.touched.feedback_details[index]?.name &&
                        Boolean(formik.errors.feedback_details?.[index]?.name)
                      }
                      helperText={
                        formik.touched.feedback_details &&
                        formik.touched.feedback_details[index]?.name &&
                        formik.errors.feedback_details?.[index]?.name
                      }
              />
                </Grid>
                <Grid item xs={3}>
                <TextField
  size="small"
  fullWidth
  placeholder="Rating"
  id="outlined-basic"
  variant="outlined"
  name={`feedback_details[${index}].rating`}
  value={vechile.rating}
  onChange={(e) => {
    const val = e.target.value;
    if (/^[1-9]?$/.test(val)) {
      formik.setFieldValue(`feedback_details[${index}].rating`, val);
    }
  }}
  onBlur={formik.handleBlur}
  error={
    formik.touched.feedback_details &&
    formik.touched.feedback_details[index]?.rating &&
    Boolean(formik.errors.feedback_details?.[index]?.rating)
  }
  helperText={
    formik.touched.feedback_details &&
    formik.touched.feedback_details[index]?.rating &&
    formik.errors.feedback_details?.[index]?.rating
  }
  inputProps={{
    inputMode: 'numeric',
    pattern: '[1-9]',
    maxLength: 1,
  }}
  sx={{
    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      MozAppearance: 'textfield',
    },
  }}
/>
                </Grid>
                
                <Grid item xs={5}>
                <TextField
                size="small"
                fullWidth
                placeholder="Remarks"
                id="outlined-basic"
                variant="outlined"
                name={`feedback_details[${index}].remarks`}
                      value={vechile.remarks}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.feedback_details &&
                        formik.touched.feedback_details[index]?.remarks &&
                        Boolean(formik.errors.feedback_details?.[index]?.remarks)
                      }
                      helperText={
                        formik.touched.feedback_details &&
                        formik.touched.feedback_details[index]?.remarks &&
                        formik.errors.feedback_details?.[index]?.remarks
                      }
              />
                </Grid>
            </Grid>
          ))}
          </Grid>
        </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{textAlign:'end'}}>
                  <Button sx={{mr: 2}} onClick={arrowBack} variant="outlined">Cancel</Button>
                  <Button type="submit" variant="contained">Create Demo</Button>
                </Grid>
            </Grid>
      </Box>
    </div>
  );
};

export default Adddemo;
